import { render } from "./ModelTagsCellRenderer.vue?vue&type=template&id=0f4009e0&scoped=true"
import script from "./ModelTagsCellRenderer.vue?vue&type=script&lang=js"
export * from "./ModelTagsCellRenderer.vue?vue&type=script&lang=js"

import "./ModelTagsCellRenderer.vue?vue&type=style&index=0&id=0f4009e0&scoped=true&lang=css"

import exportComponent from "../../../venturestar-data-emails-sentistar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4009e0"]])

export default __exports__